<div class="container">
  <div class="header d-flex flex-column flex-md-row align-items-center justify-content-between w-100">
    <div class="d-flex align-items-center">
      <wfs-wf-logo></wfs-wf-logo>
      <div class="logo-text ms-2">Webbformulär</div>
    </div>
    <div class="region-logo"></div>
  </div>
  <article class="mt-4">
    <div class="d-flex flex-column align-items-center">
      <h1>Utloggning pågår</h1>
      <p>Vänligen vänta, utloggning pågår</p>
      <wfs-spinner-loader />
    </div>
  </article>
</div>
